module.exports = __webpack_public_path__ + "img/settings.d8722a91.svg";